import React from 'react';
import { Helmet } from 'react-helmet';

const UnbounceHelmet = props => {
  return (
    <Helmet>
      <script src='//dac3df4e29b543049fc7cbe991849770.js.ubembed.com' async />
    </Helmet>
  );
};

export default UnbounceHelmet;
